import React from 'react';
import { FieldAnswerFeedbackWUT } from '../../../ui/field-answer-feedback/field-answer-feedback-wut';
import { QuizQuestionWut } from '../../../ui/quiz/quiz-question/quiz-question-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import Fieldset from '../../../ui/fieldset';
import { MediaBoxSelectionWUT } from '../../../ui/quiz/media-box-selection/media-box-selection-wut';
import { NUMBER_OF_COLUMNS } from '../../../ui/options-layout/options-layout-constants';
export const QuizImageChoiceComponent = props => {
  const {
    id,
    target,
    required = true,
    error,
    hasError = false,
    errorMessage,
    description,
    FieldLayout,
    label,
    hideLabel,
    value,
    // disabled,
    onChange,
    options,
    numberOfColumns,
    isMultipleAnswers,
    choiceImageResize,
    onFocus,
    onBlur
  } = props;
  const {
    inputId,
    labelId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const columns = !numberOfColumns || numberOfColumns === NUMBER_OF_COLUMNS.ONE ? 'single' : numberOfColumns === NUMBER_OF_COLUMNS.TWO ? 'two' : 'three';
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      labelId: labelId,
      htmlFor: inputId,
      id: id,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: props.requiredIndicatorType,
      requiredIndicatorPlacement: props.requiredIndicatorPlacement,
      image: props.questionImage,
      imageResize: props.questionImageResize,
      imageAlignment: props.questionImageAlignment,
      imagePlacement: props.questionImagePlacement,
      imageAltText: props.questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(Fieldset, {
      id: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy,
      onFocus: onFocus,
      onBlur: onBlur,
      required: required
    }, /*#__PURE__*/React.createElement(MediaBoxSelectionWUT, {
      value: value,
      onChange: onChange,
      options: options,
      isMultipleAnswers: isMultipleAnswers || false,
      fit: choiceImageResize,
      columns: columns
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), /*#__PURE__*/React.createElement(FieldAnswerFeedbackWUT, {
      target: target,
      externalData: props.externalData
    }))
  });
};
export const QuizImageChoiceWUT = props => {
  return /*#__PURE__*/React.createElement(QuizImageChoiceComponent, props);
};
//# sourceMappingURL=quiz-image-choice-wut.js.map